<template>
  <div>
    <Nav></Nav>
    <b-container fluid="xl">
      <b-row class="mt-3 mb-2" align-v="center">
        <b-col><h1 class="mb-0">Marketing → QR de descarga</h1></b-col>
      </b-row>

      <b-row class="mb-3" align-v="end">
        <b-col md="3">
          <b-form-group label="Desde" class="mb-0">
            <b-form-input v-model="from" type="date" size="sm"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Hasta" class="mb-0">
            <b-form-input v-model="to" type="date" size="sm"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Tipo" class="mb-0">
            <b-form-select v-model="qrType" :options="typeOptions" size="sm"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-button variant="primary" size="sm" block @click="load" :disabled="loading">
            <b-spinner v-if="loading" small></b-spinner> Buscar
          </b-button>
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col v-for="k in kpis" :key="k.label" cols="6" md="3" lg="2">
          <b-card no-body class="mb-2">
            <b-card-body class="py-2 px-3">
              <div class="text-uppercase text-muted" style="font-size: .7rem;">{{ k.label }}</div>
              <div class="h4 mb-0">{{ k.value }}</div>
              <small v-if="k.hint" class="text-muted">{{ k.hint }}</small>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <b-alert v-if="!loading && !rows.length" show variant="info">
        Sin escaneos en el periodo. Verifica que los QR apunten a
        <code>/download?type=…</code> y que el BFF esté publicando a central.
      </b-alert>

      <b-card v-else no-body>
        <b-card-header class="py-2">
          <strong>Detalle</strong>
          <small class="text-muted ml-2">
            "Visitantes" son únicos aproximados: hash de IP + navegador + día, sin guardar la IP.
          </small>
        </b-card-header>
        <b-table small striped hover responsive :items="rows" :fields="fields" :busy="loading">
          <template #cell(conversion_pct)="d">
            <span :class="d.item.conversion_pct > 0 ? '' : 'text-muted'">
              {{ Number(d.item.conversion_pct).toFixed(1) }}%
            </span>
          </template>
          <template #cell(qr_type)="d">
            <b-badge :variant="typeVariant(d.item.qr_type)">{{ d.item.qr_type }}</b-badge>
            <small v-if="d.item.sucursal" class="ml-1">{{ d.item.sucursal }}</small>
          </template>
        </b-table>
      </b-card>

      <b-alert v-if="sinAtribucion" show variant="warning" class="mt-3 py-2">
        <small>
          Instalaciones y registros salen en cero porque todavía no está conectado el
          proveedor de atribución diferida. El conteo de escaneos sí es exacto.
        </small>
      </b-alert>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import Nav from "../../components/Nav.vue";

export default {
  name: "qrDescargas",
  components: { Nav },
  data() {
    const hoy = new Date();
    const hace30 = new Date(hoy.getTime() - 30 * 86400000);
    const iso = (d) => d.toISOString().slice(0, 10);
    return {
      loading: false,
      from: iso(hace30),
      to: iso(hoy),
      qrType: "",
      rows: [],
      summary: {},
      byType: {},
      typeOptions: [
        { value: "", text: "Todos" },
        { value: "meta", text: "Meta" },
        { value: "tiktok", text: "TikTok" },
        { value: "sucursal", text: "Sucursal" },
        { value: "direct", text: "Directo" }
      ],
      fields: [
        { key: "day", label: "Día", sortable: true },
        { key: "qr_type", label: "Origen" },
        { key: "campaign", label: "Campaña" },
        { key: "scans", label: "Escaneos", sortable: true },
        { key: "visitors", label: "Visitantes", sortable: true },
        { key: "android", label: "Android", sortable: true },
        { key: "ios", label: "iOS", sortable: true },
        { key: "other", label: "Otro" },
        { key: "installs", label: "Instalaciones", sortable: true },
        { key: "registers", label: "Registros", sortable: true },
        { key: "conversion_pct", label: "Conv." }
      ]
    };
  },
  computed: {
    kpis() {
      const s = this.summary || {};
      const total = s.scans || 0;
      const pct = (n) => (total > 0 ? ((n / total) * 100).toFixed(0) + "%" : "—");
      return [
        { label: "Escaneos", value: total },
        { label: "Visitantes", value: s.visitors || 0, hint: "únicos aprox." },
        { label: "Android", value: s.android || 0, hint: pct(s.android || 0) },
        { label: "iOS", value: s.ios || 0, hint: pct(s.ios || 0) },
        { label: "Instalaciones", value: s.installs || 0 },
        { label: "Registros", value: s.registers || 0 }
      ];
    },
    sinAtribucion() {
      return (this.summary.scans || 0) > 0 && (this.summary.installs || 0) === 0;
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    typeVariant(t) {
      return { meta: "primary", tiktok: "dark", sucursal: "success" }[t] || "secondary";
    },
    load() {
      this.loading = true;
      axios
        .get("/report/qr-scans", { params: { from: this.from, to: this.to, type: this.qrType } })
        .then((r) => {
          const d = r.data || {};
          this.rows = d.rows || [];
          this.summary = d.summary || {};
          this.byType = d.by_type || {};
        })
        .catch((e) => {
          const msg = (e.response && e.response.data) || e.message || "Error desconocido";
          this.$bvToast.toast(typeof msg === "string" ? msg : JSON.stringify(msg), {
            title: "Error", variant: "danger", autoHideDelay: 6000
          });
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>
